/**
 * Accepts only absolute http(s) URLs from an untrusted API field; anything
 * else (non-string, blank, javascript:, relative) collapses to `null` so the
 * UI never renders a navigation target it can't vouch for. The original
 * string is returned untouched — no normalisation of the operator's URL.
 */
export function parseHttpUrl(v: unknown): string | null {
  if (typeof v !== 'string') return null;
  const s = v.trim();
  if (s === '') return null;
  try {
    const { protocol } = new URL(s);
    return protocol === 'http:' || protocol === 'https:' ? s : null;
  } catch {
    return null;
  }
}
